<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <div class="text-center mb-3">
      <h4>{{ submitConfirmTitle }}</h4>
      <p class="m-0" v-html="submitConfirmDescription"></p>
    </div>
    <template #modal-footer>
      <div class="d-flex justify-content-end gap-2 w-100">
        <b-button
            block
            variant="light"
            @click="handleCancel"
        >
          <b>{{ $t('Cancel') }}</b>
        </b-button>
        <b-button
            block
            class="m-0"
            variant="primary"
            @click="handleConfirm"
        >
          <b>{{ lodash.startCase($t('balancing_approvals.buttons.yes_confirm')) }}</b>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'

export default {
  name: 'balancing-approval-submit-confirmation',
  extends: ConfirmationModal,
  props: {
    id: {default: 'balancing-approval-submit-confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      options: {
        message: null,
        modelId: null,
      },
      resolvePromise: null,
    };
  },
  computed: {
    submitConfirmTitle() {
      return this.options.title || `${this.$t('balancing_approvals.modal_messages.confirm_submit_title')}?`
    },
    submitConfirmDescription() {
      if (this.options.message) {
        return this.options.message
      }

      const description = this.$t('balancing_approvals.modal_messages.{something}_confirm_submit_description')
      const safeSomething = this.lodash.escape(this.options.modelId || '')

      return description.replace('{something}', `<strong>${safeSomething}</strong>`)
    }
  },
  methods: {
    show(options = {}) {
      return new Promise((resolve) => {
        this.options = {
          message: null,
          modelId: null,
          ...options,
        }
        this.$bvModal.show(this.id)

        this.resolvePromise = resolve
      });
    },
    handleConfirm() {
      if (this.resolvePromise) {
        this.resolvePromise(true)
      }
      this.hide()
    },
    handleCancel() {
      if (this.resolvePromise) {
        this.resolvePromise(false)
      }
      this.hide()
    },
    hide() {
      this.$bvModal.hide(this.id)
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
